// extracted by mini-css-extract-plugin
export default {"viewPhoneNumberButton":"FUnPAuISOZsiBhE9edYWG"};